import Axios from "axios";
import {
    SET_CS_QUOTATION_LIST,
    UNSET_CS_QUOTATION_LIST,
  } from "@/store/mutation-types";
import {saveUpdateCsQuotation, getCsQuotationList, getCsQuotationById as getCsQuotationByIdApi } from "@/store/api";
// initial state
const state = {
  getCsQuotationList: [],
  editingCsQuotation: null,
};

const getters = {
  getCsQuotationList(state) {
    return state.getCsQuotationList;
  },
  getEditingCsQuotation: (state) => { 
    return state.editingCsQuotation;
  },
};

const mutations = {
  [SET_CS_QUOTATION_LIST](state, data) {
    state.getCsQuotationList = data;
  },
  [UNSET_CS_QUOTATION_LIST](state) {
    state.getCsQuotationList = [];
  },
  setEditingCsQuotation(state, csQuotation) {
    state.editingCsQuotation = csQuotation;
  },
};

const actions = {
  saveUpdateCsQuotation({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCsQuotation, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCsQuotationList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCsQuotationList, data)
        .then(function (response) {
          commit('SET_CS_QUOTATION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CS_QUOTATION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getCsQuotationById({ commit }, id) {
    const getCsQuotationById = `${getCsQuotationByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getCsQuotationById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
